import "./outcome.css";

export default function DefaultOutcome() {
	return (
		<div className="outcome">
			{/* <p>Please, enter a product in the search bar</p> */}
		</div>
	);

}